import { AdditionalInformation } from '@/lib/apiTypes';
import { EditorialErrorIdentifier } from '@/components/EditorialErrors/EditorialErrors';

const identifyMissingDescription: EditorialErrorIdentifier = ({
	useSpecies,
}) => {
	const { species } = useSpecies;
	if (!species) return [];

	return species.data
		.filter((singleSpecies) => {
			const descriptionsWithMissingWords = Object.values(
				singleSpecies.attributes.speciesDescription
			).filter((description: number | AdditionalInformation) => {
				if (typeof description === 'number') return false;
				return description.description.split(' ').length < 4;
			});
			return descriptionsWithMissingWords.length > 0;
		})
		.map((singleSpecies) => ({
			title: 'Missende beschrijving',
			description: `${singleSpecies.attributes.titleShort} heeft beschrijvingen met minder dan 4 woorden.`,
			speciesId: singleSpecies.id,
		}));
};

export default identifyMissingDescription;
